export const camelToKebab = (str: string): string => str
  .replace(/([A-Z])/g, '-$1')
  .toLowerCase();

export const slugify = (input: string): string => {
  const separator = '-';

  if (!input) {
    return '';
  }

  let str = String(input);

  // 1) Semantic replacements BEFORE normalization (cases that don’t decompose well)
  const preMap: Record<string, string> = {
    ß: 'ss',
    đ: 'dj',
    Đ: 'Dj',
    ǆ: 'dz',
    ǅ: 'Dz',
    Ǆ: 'DZ',
    æ: 'ae',
    Æ: 'AE',
    œ: 'oe',
    Œ: 'OE',
    þ: 'th',
    Þ: 'Th',
    ł: 'l',
    Ł: 'L',
    ø: 'o',
    Ø: 'O',
    İ: 'I',
    ı: 'i',
    ƞ: 'n',
    Ŋ: 'N',
    ŋ: 'ng',
    č: 'c',
    Č: 'C',
    ć: 'c',
    Ć: 'C',
    š: 's',
    Š: 'S',
    ž: 'z',
    Ž: 'Z',
  };

  // Replace character by character using preMap
  str = Array.from(str, (ch) => preMap[ch] ?? ch).join('');

  // 2) Unicode normalization + remove diacritic marks
  //    NFKD splits “base letter” + “mark”, then we strip out \p{M} (marks)
  str = str.normalize('NFKD').replace(/\p{M}+/gu, '');

  // 3) Convert to lowercase
  str = str.toLowerCase();

  // 4) Replace separators: anything that is not a letter/number becomes `separator`
  //    \p{L} = letters, \p{N} = numbers (Unicode aware)
  const nonWord = /[^\p{L}\p{N}]+/gu;
  str = str.replace(nonWord, separator);

  // 5) Collapse multiple separators into one
  const sepEscaped = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const multiSep = new RegExp(`${sepEscaped}{2,}`, 'g');
  str = str.replace(multiSep, separator);

  // 6) Trim separators at the edges
  const edgeSep = new RegExp(`^${sepEscaped}|${sepEscaped}$`, 'g');
  str = str.replace(edgeSep, '');

  return str;
};
